<section class="messages-add-new bg-white mx-auto">
    <quill-editor
        class="messages-quill-editor w-full"
        [formControl]="quillFormControl"
        [modules]="quillModules"
        placeholder="What can we help you with?"
        [sanitize]="true"
    />
    <!-- Using a custom toolbar so we can place it underneath the editor. -->
    <div id="custom-quill-toolbar">
        <div class="toolbar-divider"></div>
        <div
            class="custom-quill-toolbar-buttons flex items-center h-full gap-2"
        >
            <button class="ql-bold ml-[15px]"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-list ml-4" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <span class="ml-auto mr-2">
                @if (isSaving()) {
                    <mat-spinner [diameter]="16" />
                } @else {
                    <span class="lendio-density-2">
                        <button
                            mat-icon-button
                            (click)="addMessage(quillFormControl.value)"
                            [disabled]="quillFormControl.invalid">
                            <mat-icon class="material-icons-outlined">send</mat-icon>
                        </button>
                    </span>
                }
            </span>
        </div>
    </div>
    <!-- Validation errors -->
    @if (quillFormControl.hasError('maxlength') ||
    quillFormControl.hasError('serverError')) {
        <div class="h-6 add-message-validation-error">
            @if (quillFormControl.hasError('maxlength')) {
                <mat-error> Message exceeds maximum length. </mat-error>
            } @if (quillFormControl.hasError('serverError')) {
                <mat-error>
                    An error occurred while sending the message.
                </mat-error>
            }
        </div>
    }
</section>
